import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    banner: {
      padding: '12px 40px',
      background: colors.darkestBlue,
      color: colors.resiliaWhite,
      height: '72px',
      display: 'flex',
      alignItems: 'center',
      '& a': {
        textDecoration: 'none',
      },
    },
    icon: {
      marginRight: '14px',
      color: colors.darkGrey,
    },
    text: {
      flex: 1,
      fontWeight: 600,
      fontSize: '16px',
    },
    button: {
      color: colors.lightestBlue,
      padding: '13px 16px',
      fontSize: '16px',
      '&:hover': {
        background: '#003263',
      },
    },
    closeIcon: {
      marginLeft: '16px',
      cursor: 'pointer',
    },
    [theme.breakpoints.down('xs')]: {
      icon: {
        display: 'none',
      },
      banner: {
        padding: '12px 18px',
        height: '150px',
        flexDirection: 'column',
      },
      text: {
        marginRight: '34px',
      },
      closeIcon: {
        position: 'absolute',
        right: '15px',
      },
      button: {
        alignSelf: 'flex-end',
      },
    },
  })
)
